import { render } from "./postitem.vue?vue&type=template&id=015ce785&scoped=true"
import script from "./postitem.vue?vue&type=script&lang=js"
export * from "./postitem.vue?vue&type=script&lang=js"

import "./postitem.vue?vue&type=style&index=0&id=015ce785&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015ce785"]])

export default __exports__